import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/_containers';
import Loading from '@/_pages/inventories/parent-profile/loading';

export const Route = createFileRoute('/_private/inventory/parent/$id')({
  pendingComponent: () => (
    <ContainerLayout>
      <Loading />
    </ContainerLayout>
  ),
});
